import React, { Component } from 'react';
import getDisplayName from 'src/utils/get-display-name';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { observer } from 'mobx-react';
/*
 HOC that waits for promised props to resolve before rendering.

 `getPropsPromise(props)` returns a promise that resolves with an object
 that will be merged with `AsyncProps`'s props to obtain the props for
 the `WrappedComponent`.
 */
export default function asyncProps(getPropsPromise, loadingProp = null) {
  return (WrappedComponent) => {
    @observer
    class AsyncProps extends Component {
      state = {
        resolvedProps: undefined,
      };

      loadAsyncProps = async () => {
        const resolvedProps = await getPropsPromise(this.props);
        this.setState({
          resolvedProps,
        });
      };

      componentDidMount() {
        this.loadAsyncProps();
      }

      render() {
        if (!this.state.resolvedProps && loadingProp === null) {
          return null;
        } else if (!this.state.resolvedProps) {
          if (React.isValidElement(loadingProp)) {
            return loadingProp;
          }
          return (
            <WrappedComponent
              {...this.props}
              {...{
                [loadingProp]: true,
              }}
              reloadAsyncProps={this.loadAsyncProps}
            />
          );
        }
        return (
          <WrappedComponent
            {...this.state.resolvedProps}
            {...this.props}
            reloadAsyncProps={this.loadAsyncProps}
            {...(loadingProp
              ? {
                  [loadingProp]: false,
                }
              : {})}
          />
        );
      }
    }

    hoistNonReactStatics(AsyncProps, WrappedComponent);
    AsyncProps.displayName = `AsyncProps(${getDisplayName(WrappedComponent)})`;
    return AsyncProps;
  };
}
